import {
    FirebaseApp,
    initializeApp
} from "@firebase/app";

import {
    limitToLast,
    Database,
    getDatabase,
    connectDatabaseEmulator,
    ref,
    set,
    push,
    onValue,
    orderByChild,
    query,
    update,
    remove
} from "@firebase/database";

import {
    Auth,
    getAuth,
    connectAuthEmulator
} from "@firebase/auth";
import {
    CodeEntry,
    Session,
    SessionAnimations,
    SessionGroup,
    SessionGroupBySession
} from "./objects";


var firebaseConfig = {
    apiKey: "AIzaSyDAFS9zGiDO6z572wHuoT16MerNRAmNCnU",
    authDomain: "pixels-16188.firebaseapp.com",
    databaseURL: "https://pixels-16188-default-rtdb.europe-west1.firebasedatabase.app",
    projectId: "pixels-16188",
    storageBucket: "pixels-16188.appspot.com",
    messagingSenderId: "126665136060",
    appId: "1:126665136060:web:2902ba46571c308a1afdb9",
};
1


export var db: Database;
export var firebaseapp: FirebaseApp;
export var auth: Auth;

export function initFirebase(): void {
    initializeApp(firebaseConfig);
    db = getDatabase(firebaseapp);
    auth = getAuth(firebaseapp);

    if (location.hostname === 'localhost') {
        connectDatabaseEmulator(db, "localhost", 9000);
        connectAuthEmulator(auth, "http://localhost:9099");
    }
}

export function isAdmin(user_id: string): Promise < boolean > {
    let admins_ref = ref(db, "admins/" + user_id);
    return new Promise((resolve, reject) => {
        onValue(admins_ref, (data) => {
            resolve(data.exists());
        }, () => {
            resolve(false);
        }, {
            onlyOnce: true
        });
    });
}

export function listenSessionGroups(callback: (r: {
    [key: string]: SessionGroup
}) => void) {
    let session_groups = ref(db, "session_groups");
    onValue(session_groups, (data) => {
        if (data.exists()) {
            callback( < {
                [key: string]: SessionGroup
            } > data.toJSON());
        } else {
            callback({});
        }
    });
}


export function getCode(code: string): Promise < CodeEntry | undefined > {
    let code_ref = ref(db, "codes/" + code);
    let q = query(code_ref, orderByChild("session_end_date"), limitToLast(1));

    return new Promise((resolve, reject) => {
        onValue(q, (data) => {
            if (!data.exists()) {
                resolve(undefined);
            } else {
                var result = < {
                    [key: string]: CodeEntry
                } > data.toJSON();
                var result_list = Object.values(result);
                if (result_list.length > 0) {
                    if (new Date() <= new Date(result_list[0].session_end_date)) {
                        resolve(result_list[0]);
                    } else {
                        resolve(undefined);
                    }
                } else {
                    resolve(undefined);
                }
            }
        }, (error) => reject(error), {
            onlyOnce: true
        });

    });
}

export function getSessionsFromGroup(session_group: string): Promise < SessionGroupBySession > {
    let session_group_ref = ref(db, "sessions/" + session_group);
    return new Promise((resolve, reject) => {
        onValue(session_group_ref, (data) => {
            if (!data.exists()) {
                reject("Session not found");
            } else {
                resolve( < SessionGroupBySession > data.toJSON());
            }
        }, (error) => reject(error), {
            onlyOnce: true
        });
    });
}

export function listenSessionsFromGroup(session_group: string, callback: (data: {
    [key: string]: Session
}) => void, error: (e: Error) => void): void {
    let session_ref = ref(db, "sessions/" + session_group + "/sessions");

    onValue(session_ref, (data_snapshot) => {
        if (data_snapshot.exists()) {
            callback( < {
                [key: string]: Session
            } > data_snapshot.toJSON());
        } else {
            callback({});
        }
    }, (e) => error(e));
}

export function listenToAnimations(sessionId: string, callback: (data: SessionAnimations) => void, error: (e: Error) => void) {
    let animations_ref = ref(db, "animations/" + sessionId);

    onValue(animations_ref, (data_snapshot) => {
        if (data_snapshot.exists()) {
            callback( < SessionAnimations > data_snapshot.toJSON());
        } else {
            error(new Error("Session animations not found"));
        }
    }, (e) => error(e));
}

export function listenToAnimationsGif(sessionId: string, callback: (data: string[]) => void, error: (e: Error) => void) {
    let animations_ref = ref(db, "animations/" + sessionId + "/animations");

    onValue(animations_ref, (data_snapshot) => {
        if (data_snapshot.exists()) {
            callback( < string[] > data_snapshot.toJSON());
        } else {
            error(new Error("Animations not found"));
        }
    }, (e) => error(e));
}


export function setUserSecret(uid: string, secret: string): Promise < void > {
    var r = ref(db, "user_secrets/" + uid + "/" + secret);
    return set(r, 1);
}

export async function createSessionGroup(session_group_name: string, session_group_description: string, secret: string): Promise < void > {
    var session_groups_ref = ref(db, "session_groups");


    var data = await push(session_groups_ref, {
        session_group_name: session_group_name,
        session_group_description: session_group_description,
        session_group_secret: secret,
    })

    return set(ref(db, "sessions/" + data.key), {
        session_group_name: session_group_name,
        session_group_description: session_group_description,
        sessions: {},
    });
}

export async function createSession(session_group: string, session_name: string, session_description: string, session_end_date: number, session_code: string): Promise < void > {
    let sessions_ref = ref(db, "sessions/" + session_group + "/sessions");
    let session = await push(sessions_ref, { session_name, session_description, session_end_date, session_code });
    let animation_ref = ref(db, "animations/" + session.key);
    await set(animation_ref, { session_name, session_description, session_end_date, session_code, session_group, animations: {}});
    let coderef = ref(db, "codes/" + session_code + "/" + session.key);
    return set(coderef, { session_key: session.key, session_end_date, session_group });
}

export function pushTiledImage(data: any): Promise<void> {
    let tiled_images = ref(db, "tiled_images/");
    return new Promise((resolve, reject) => {
        push(tiled_images, data).then(() => resolve()).catch(e => reject(e));
    });
}

export function pushAnimation(sessionId: string, anim: string): Promise<void> {
    let animations_ref = ref(db, "animations/" + sessionId + "/animations");
    return new Promise((resolve, reject) => {
        push(animations_ref, anim).then(() => resolve()).catch(e => reject(e));
    });
}

export function getTiledImages() : Promise<any> {
    let tiled_images = ref(db, "tiled_images/");

    return new Promise((resolve, reject) => {
        onValue(tiled_images, (data) => {
            if(data.exists()) {
                resolve(<string> <unknown> data.toJSON());
            } else {
                reject();
            }
        }, (error) => {
            reject(error);
        }, {onlyOnce: true})
    });
}

export function getSessionCode(session_group: string, session_id: string) : Promise<string> {
    let code_ref = ref(db, `sessions/${session_group}/sessions/${session_id}/session_code`);
    return new Promise((resolve, reject) => {
        onValue(code_ref, (data) => {
            if(data.exists()) {
                resolve(<string> <unknown> data.toJSON());
            } else {
                reject();
            }
        }, (error) => {
            reject(error);
        }, {onlyOnce: true})
    });
}

export async function setSessionEndDate(session_group: string, session_id: string, setSessionEndDate: number) : Promise<void> {
    let session_ref = ref(db, "sessions/" + session_group + "/sessions/" + session_id);
    await update(session_ref, { "session_end_date": setSessionEndDate });
    let code = await getSessionCode(session_group, session_id);
    await update(ref(db, `codes/${code}/${session_id}/`), { "session_end_date": setSessionEndDate });
    return update(ref(db, `animations/${session_id}`), { "session_end_date": setSessionEndDate });
}

export function deleteAnimation(sessionId: string, imageKey: string): Promise<void> {
    let animation_ref = ref(db, "animations/" + sessionId + "/animations/" + imageKey);
    return remove(animation_ref);
}

export function updateImageCountForSession(session: string): Promise<number> {
    let animations_ref = ref(db, "animations/" + session);

    return new Promise(function(resolve, reject) {
        onValue(animations_ref, (data_snapshot) => {
            if (data_snapshot.exists()) {
                let d = <any>data_snapshot.toJSON();
                let count = d && d.animations && Object.keys(d.animations).length || 0;
                resolve(count);
                update(ref(db, `sessions/${d.session_group}/sessions/${session}`), { image_count: count }).catch(
                    (error) => {
                        alert(alert("Error computing image count for session: " + session + ": " + error));
                    }
                );
            } else {
                alert("Error computing image count for session: " + session);
                reject();
            }
        }, (e) => { alert("Error computing image count for session: " + session + ": " + e); reject(e); },
        { onlyOnce: true });
    });

}


export async function updateSessionGroupCounts(session_group: string) : Promise<void> {
    let session_group_data = await getSessionsFromGroup(session_group);
    let sessions = session_group_data.sessions || {};
    let session_count = Object.keys(sessions).length;
    let image_count : {[key: string]: number} = {};
    let total_images = 0;
    let sessions_with_images = 0;

    for (const session of Object.keys(sessions)) {
        image_count[session] = await updateImageCountForSession(session);
        total_images += image_count[session];
        if (image_count[session] > 0) {
            sessions_with_images += 1;
        }
    }

    return update(ref(db, `session_groups/${session_group}`), {
        image_count: total_images,
        sessions_with_images,
        session_count    
    });
}